import React from "react";
import styled from "styled-components";
import Board from "../Board/Board";

interface UserDashboardPageHeaderProps {
  title: string;
  children?: React.ReactNode;
}

const UserDashboardPageHeader = ({
  title,
  children,
}: UserDashboardPageHeaderProps) => {
  return (
    <UserDashboardPageHeaderLayout>
      <h1>{title}</h1>
      <div>{children}</div>
    </UserDashboardPageHeaderLayout>
  );
};

export default UserDashboardPageHeader;

const UserDashboardPageHeaderLayout = styled(Board)`
  padding: 3rem 4rem;
  display: flex;
  justify-content: space-between;

  h1 {
    font-size: 28px;
    font-weight: 600;
    line-height: 36px; /* 128.571% */
    letter-spacing: -0.56px;
  }
`;
